import React, { Component } from 'react';
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel } from 'react-accessible-accordion';
import { HexAlphaColorPicker, HexColorInput } from 'react-colorful';
import getFonts from '../../../Functions/config/fonts';
import getSelectField from '../../fields/select';
import toggleColorPicker from '../../../Functions/toggleColorPicker';

class HeaderSettings extends Component {
    constructor(props) {
        super(props);
    }

    renderIncrementalSetting = (label, value, name, step = 1, min = 0) => {
        let displayValue = value;
        let unit = 'px';

        if (name === 'header.headerLogoSize') {
            unit = '%';
        }

        if (typeof value === 'string') {
            const match = value.match(/^([\d.]+)(.*)$/);
            if (match) {
                displayValue = match[1];
            }
        }

        return (
            <div className='mjwi-row'>
                <div className='mjwi-col50'>
                    <label>{label}</label>
                </div>
                <div className='mjwi-col50'>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                            type="number"
                            name={name}
                            value={displayValue || ''}
                            onChange={(e) => {
                                const val = e.target.value;
                                this.props.handleInputChange({ target: { name, value: val ? `${parseFloat(val) || 0}${unit}` : `0${unit}` } }, ['header']);
                            }}
                            className="mjwi-input"
                            min={min}
                            style={{ flexGrow: 1 }}
                        />
                    </div>
                </div>
            </div>
        );
    };

    renderColorPicker = (label, color, field) => (
        <div className="mjwi-row">
            <div className="mjwi-col50">
                <label>{label}</label>
            </div>
            <div className="mjwi-col50 mjwi-clr-picker">
                <span
                    className="clrPickerVal"
                    onClick={toggleColorPicker}
                    style={{ backgroundColor: color }}
                ></span>
                <HexAlphaColorPicker
                    color={color}
                    onChange={(newColor) => this.props.setColorsAndPreview('header', field, newColor)}
                    className="mjwi-apfl-color-picker"
                    style={{ display: 'none' }}
                />
                <HexColorInput
                    color={color}
                    onChange={(newColor) => this.props.setColorsAndPreview('header', field, newColor)}
                    className="mjwi-color-input"
                />
            </div>
        </div>
    );

    renderDropdown = (label, name, value, options) => (
        <div className="mjwi-row">
            <div className="mjwi-col50">
                <label>{label}</label>
            </div>
            <div className="mjwi-col50">
                {getSelectField(name, options.map(opt => opt.label), value, (e) => this.props.handleInputChange(e, ['header']))}
            </div>
        </div>
    );

    renderBackgroundSettings = () => {
        const { tripadvisor } = this.props;
        return (
            <div className='mjwi-acc-panel-wrapper'>
                {this.renderColorPicker('Background', tripadvisor.header.headerBackgroundColor, 'headerBackgroundColor')}
                {this.renderIncrementalSetting('Border Radius', tripadvisor.header.headerBorderRadius, 'header.headerBorderRadius', 1)}
            </div>
        );
    };

    renderTitleSettings = () => {
        const { tripadvisor } = this.props;
        const fontFamilyOptions = getFonts().map(font => ({ value: font, label: font }));
        const fontWeightOptions = [
            { value: 'normal', label: 'Normal' },
            { value: 'bold', label: 'Bold' },
            { value: '100', label: '100' },
            { value: '200', label: '200' },
            { value: '300', label: '300' },
            { value: '400', label: '400' },
            { value: '500', label: '500' },
            { value: '600', label: '600' },
            { value: '700', label: '700' },
            { value: '800', label: '800' },
            { value: '900', label: '900' }
        ];

        return (
            <div className='mjwi-acc-panel-wrapper'>
                {this.renderColorPicker('Color', tripadvisor.header.companyNameColor, 'companyNameColor')}
                {this.renderDropdown('Font Family', 'header.companyNameFontFamily', tripadvisor.header.companyNameFontFamily, fontFamilyOptions)}
                {this.renderDropdown('Font Weight', 'header.companyNameFontBold', tripadvisor.header.companyNameFontBold, fontWeightOptions)}
                {this.renderIncrementalSetting('Font Size', tripadvisor.header.companyNameFontSize, 'header.companyNameFontSize', 1)}
            </div>
        );
    };

    renderTotalReviewsSettings = () => {
        const { tripadvisor } = this.props;
        const fontFamilyOptions = getFonts().map(font => ({ value: font, label: font }));
        const fontWeightOptions = [
            { value: 'normal', label: 'Normal' },
            { value: 'bold', label: 'Bold' },
            { value: '100', label: '100' },
            { value: '200', label: '200' },
            { value: '300', label: '300' },
            { value: '400', label: '400' },
            { value: '500', label: '500' },
            { value: '600', label: '600' },
            { value: '700', label: '700' },
            { value: '800', label: '800' },
            { value: '900', label: '900' }
        ];

        return (
            <div className='mjwi-acc-panel-wrapper'>
                {this.renderColorPicker('Color', tripadvisor.header.totalReviewsColor, 'totalReviewsColor')}
                {this.renderDropdown('Font Family', 'header.totalReviewsFontFamily', tripadvisor.header.totalReviewsFontFamily, fontFamilyOptions)}
                {this.renderDropdown('Font Weight', 'header.totalReviewsFontBold', tripadvisor.header.totalReviewsFontBold, fontWeightOptions)}
                {this.renderIncrementalSetting('Font Size', tripadvisor.header.totalReviewsFontSize, 'header.totalReviewsFontSize', 1)}
            </div>
        );
    };

    renderLogoSettings = () => {
        const { tripadvisor } = this.props;
        const alignmentOptions = [
            { value: 'left', label: 'Left' },
            { value: 'center', label: 'Center' },
            { value: 'right', label: 'Right' }
        ];

        return (
            <div className='mjwi-acc-panel-wrapper'>
                {this.renderDropdown('Alignment', 'header.logoAlignment', tripadvisor.header.logoAlignment, alignmentOptions)}
                {this.renderIncrementalSetting('Size', tripadvisor.header.logoSize, 'header.logoSize', 1)}
            </div>
        );
    };

    renderRatingSettings = () => {
        const { tripadvisor } = this.props;
        const fontFamilyOptions = getFonts().map(font => ({ value: font, label: font }));
        const fontWeightOptions = [
            { value: 'normal', label: 'Normal' },
            { value: 'bold', label: 'Bold' },
            { value: '100', label: '100' },
            { value: '200', label: '200' },
            { value: '300', label: '300' },
            { value: '400', label: '400' },
            { value: '500', label: '500' },
            { value: '600', label: '600' },
            { value: '700', label: '700' },
            { value: '800', label: '800' },
            { value: '900', label: '900' }
        ];

        return (
            <div className='mjwi-acc-panel-wrapper'>
                {this.renderColorPicker('Number Color', tripadvisor.header.ratingColor || '#00aa6c', 'ratingColor')}
                {this.renderColorPicker('Star Color', tripadvisor.header.ratingStarColor || '#00aa6c', 'ratingStarColor')}
                {this.renderColorPicker('Empty Star Color', tripadvisor.header.ratingStarEmptyColor || '#e5e5e5', 'ratingStarEmptyColor')}
                {this.renderIncrementalSetting('Star Size', tripadvisor.header.ratingStarSize || '20px', 'header.ratingStarSize', 1)}
                {this.renderColorPicker('Count Color', tripadvisor.header.ratingCountColor || '#666666', 'ratingCountColor')}
                {this.renderDropdown('Font Family', 'header.ratingFontFamily', tripadvisor.header.ratingFontFamily || 'Arial, sans-serif', fontFamilyOptions)}
                {this.renderDropdown('Font Weight', 'header.ratingFontBold', tripadvisor.header.ratingFontBold || 'bold', fontWeightOptions)}
                {this.renderIncrementalSetting('Font Size', tripadvisor.header.ratingFontSize || '16px', 'header.ratingFontSize', 1)}
            </div>
        );
    };

    renderHeaderSettings = () => {
        const { tripadvisor } = this.props;
        return (
            <Accordion allowZeroExpanded={true}>
            {tripadvisor.header.showHeader && (
                    <>
                        <AccordionItem className='mjwi-sub-accordion'>
                            <AccordionItemHeading>
                                <AccordionItemButton>
                                    Container
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                {this.renderBackgroundSettings()}
                            </AccordionItemPanel>
                        </AccordionItem>
                        {tripadvisor.header.showLogo && (
                            <AccordionItem className='mjwi-sub-accordion'>
                                <AccordionItemHeading>
                                    <AccordionItemButton>
                                        Logo
                                    </AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                    {this.renderLogoSettings()}
                                </AccordionItemPanel>
                            </AccordionItem>
                        )}
                        {tripadvisor.header.showCompanyName && (
                            <AccordionItem className='mjwi-sub-accordion'>
                                <AccordionItemHeading>
                                    <AccordionItemButton>
                                        Title
                                    </AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                    {this.renderTitleSettings()}
                                </AccordionItemPanel>
                            </AccordionItem>
                        )}
                        {tripadvisor.header.showTotalReviews && (
                            <AccordionItem className='mjwi-sub-accordion'>
                                <AccordionItemHeading>
                                    <AccordionItemButton>
                                        Total Reviews
                                    </AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                    {this.renderTotalReviewsSettings()}
                                </AccordionItemPanel>
                            </AccordionItem>
                        )}
                        {tripadvisor.header.showRating && (
                            <AccordionItem className='mjwi-sub-accordion'>
                                <AccordionItemHeading>
                                    <AccordionItemButton>
                                        Rating Display
                                    </AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                    {this.renderRatingSettings()}
                                </AccordionItemPanel>
                            </AccordionItem>
                        )}
                    </>
                )}
            </Accordion>
        );
    };

    render() {
        return this.props.renderSection('Header', this.renderHeaderSettings(), 'header-settings');
    }
}

export default HeaderSettings;